module.exports = __webpack_public_path__ + "static/other/lab_diagnosis_color_changer_info_scene.b226a0d1.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/labDiagnosisGame/lab_diagnosis_color_changer_info_scene.json
// module id = 2235
// module chunks = 0